// Product ID to single Variant ID mapping
let tangent_selected_product_map;

let default_addToCartText = "Add To bag";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to bag";
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_client_domain_currency;
// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
  section_essentials:"essential",
  section_advanced:"advanced"
}

const hairThinningInfo = [
  "Your strands are looking strong, full and thriving. Keep riding the momentum and stay consistent with your routine.",
  "You're noticing the first signs of thinning - minor but worth catching early. With a little targeted support, you're set to stay ahead.",
  "This is more than just shedding - you're entering the zone where volume has started to shift. Time to step up with focused repair and shedding care.",
  "Thinning has clearly taken hold and your roots are begging for attention. Let's switch into recovery mode and bring in heavy-duty support for fullness.",
  "Your hair is in a full-on comeback condition. Scalp, strand and density all need extra love - let's go all in on restoring what's been lost."
]

const heroProductText = {
  Dryness: "Spotted dryness? <a href='/products/miracle-mask' target='_blank' class='tooltip-product-link'>Miracle Hair Mask</a> and <a href='/products/rapid-repair-bond-builder-finishing-oil' target='_blank' class='tooltip-product-link'>Rapid Repair Bond Builder+ Finishing Oil</a> to the rescue!",
  Frizz:  "Spotted flyaways? <a href='/products/anti-frizz-flyaway-wand' target='_blank' class='tooltip-product-link'>Anti-Frizz Flyaway Wand</a> to the rescue!",
  Shine: "Spotted shine? <a href='/products/miracle-mask' target='_blank' class='tooltip-product-link'>Miracle Hair Mask</a> to the rescue!",
  "Split Ends": "Spotted split ends? <a href='/products/rapid-repair-bond-builder-leave-in-mask' target='_blank' class='tooltip-product-link'>Rapid Repair Bond Builder+ Leave-In Mask</a> and <a href='/products/miracle-mask' target='_blank' class='tooltip-product-link'>Miracle Hair Mask</a> to the rescue!"
}

const default_selfie_image_url = "https://file.tangent.ai/quiz-content/merchants/bondi-boost-usa/image/2270116821139354-Aloe%20vera%20c.jpg";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

const condition_img_map = {
    0: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/6724274927437921-exceptional.png",
    1: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/07050205263636644-healthy.png",    
    2: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/08533771892091924-mild.png",    
    3: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/4590586797331133-moderate.png",    
    4: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/1892010233052941-significant.png"
}

window.addEventListener("load", (event) => {
     init();
});

const init = () => {
    const window_url = new URL(window.location.href);
    const resp_id = window_url.searchParams.get("resp_id");

    fetchRecommendation(resp_id).then(recommendation_data => {
      callHairDamageApi(recommendation_data.selfie_id, recommendation_data);
      showProductsRecommendation(recommendation_data);
      
      setElementDisplay("#tangent-main-loader","none");

      attachScrollToEvent()
    }
    ).catch((e) => { console.log(e) });
}

function attachScrollToEvent(){
    document.querySelectorAll(".scroll-to-btn").forEach((element)=>{
        element.addEventListener("click", ()=>{
            const target = document.getElementById(element.dataset.scrollto);
            if(target){
                const top = target.getBoundingClientRect().top + window.pageYOffset - 80;
                window.scrollTo({
                    top,
                    behavior: 'smooth'
                });
            }
        })
    })
}


const fetchRecommendation = async (resp_id) => {
    response_id = resp_id;
    if(!response_id) throw new Error('No response ID provided');

    const url = `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${response_id}&self_serve=true`
    return fetch(url).then(response => response.json());
}

function callHairDamageApi(selfie_id, recommendation_data){
  if(selfie_id){
    const url = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfie_id}&user=mango`

    var settings = {
        "url": url,
        "method": "GET",
        "headers": {
            "Content-Type": "application/json",
        },
    };
      
    $.ajax(settings).done(function (response) {
      showLoader(true);

      setSelfieImage(response.url);
      if (response.selfie_record?.[0]?.hairdamage) {
          const hairDamage = response.selfie_record[0].hairdamage;

          // Set hair damage image if score exists
          const score = hairDamage?.damage?.score ?? null;
          if (score !== null) {
            setHairDamageImage(score);
          }

          // Set loader with health score, defaulting to 0 if missing
          loaderSet(Math.round(hairDamage?.health_score ?? 0));

          // Draw chart with hair damage data
          drawChart(hairDamage);

          setElementDisplay("#analysis_container","flex");
        }
        else{
          const hair_score = calculateHairScore(recommendation_data.tags);
          loaderSet(hair_score);
          showLoader(false);
        }

        loadElementsAfterData();
    }).fail(function(data){
      console.log("data fetch error occured : ",data)
    });;
  }
  else{
    const hair_score = calculateHairScore(recommendation_data.tags);
    loaderSet(hair_score);
    const charContainer = document.getElementById("analysis_container");
    charContainer.remove();
    const image_container = document.getElementById("image_container");
    image_container.innerHTML = `<img src="${default_selfie_image_url}" class="default_selfie_image">`;
  }
}

function calculateHairScore(tags) {
  const categories = {
    hairType: {
      options: {
        hairtype_straight: 9,
        hairtype_wavy: 9,
        hairtype_curly: 8,
        hairtype_coily: 7,
      },
      default: 8,
    },
    texture: {
      options: {
        texture_medium: 13,
        texture_fine: 11,
        texture_thick: 14,
      },
      default: 12,
    },
    concern: {
      options: {
        hair_concern_hairfall: 23,
        hair_concern_volume: 23,
        hair_concern_healthy_hair: 20,
        hair_concern_frizz: 20,
        hair_concern_breakage: 17,
        hair_concern_dandruff: 15,
        hair_concern_growth: 15,
      },
      default: 18,
    },
    scalp: {
      options: {
        scalp_balanced: 19,
        scalp_oily: 17,
        scalp_dry: 17,
        scalp_itchy: 15,
      },
      default: 17,
    },
    thinning: {
      options: {
        hair_thinning_none: 14,
        hair_thinning_little: 12,
        hair_thinning_yes: 10,
      },
      default: 12,
    },
  };

  //Compute total raw score (taking lowest score if multiple tags per category)
  const totalRawScore = Object.values(categories).reduce((sum, { options, default: def }) => {
    const matched = Object.entries(options)
      .filter(([key]) => tags.includes(key))
      .map(([_, val]) => val);

    const categoryScore = matched.length ? Math.min(...matched) : def;
    return sum + categoryScore;
  }, 0);

  //Determine dynamic normalization based on total possible points (since supplement removed)
  const maxPossibleScore = Object.values(categories).reduce(
    (sum, { options }) => sum + Math.max(...Object.values(options)),
    0
  );

  const minPossibleScore = Object.values(categories).reduce(
    (sum, { options }) => sum + Math.min(...Object.values(options)),
    0
  );

  // Normalize to 70–85 range
  const normalizedScore = 70 + (totalRawScore - minPossibleScore) / (maxPossibleScore - minPossibleScore) * 15;
  // Round to 1 decimal
  return Math.ceil((normalizedScore * 10) / 10);
}

function loadElementsAfterData(){
  document.querySelectorAll(`.load-on-data`).forEach(el => {
    el.style.display="flex";
  });
}

function setElementDisplay(selector, style){
  const element = document.querySelector(selector);
  if (element) {
    element.style.display=style;
  }
}

function loaderSet(percent){
    document.querySelector(".hair-score-hero-section").style.display = "flex";
    const progressValue = document.querySelector(".percentage");
    let startValue = 0,
        endValue = percent,
        speed = 10;

    const progress = setInterval(() => {
        startValue++;
        progressValue.textContent = `${startValue}%`;

        if (startValue === endValue) {
            clearInterval(progress);
        }
    }, speed);
}

function getAttributeScore(attributeMap, attributeName, minimum=0.2){
    if(attributeMap.hasOwnProperty(attributeName)){
        // Differentiating between not detected and insignificant detection by using a minimum value
        return Math.max(attributeMap[attributeName].score, minimum); 
    }
    return 0;
}

const attributeStyle = {
    "Dryness": {color: '#F4B3CE', fillColor: '#F4B3CE22'}, // pink
    "Shine": {color: '#799FCB', fillColor: '#799FCB22'}, // blue
    "Flyaways": {color: '#9884C7', fillColor: '#9884C722'}, // purple
    "Frizz": {color: '#FAEFD7', fillColor: '#FAEFD722'}, // yellow
    "Split Ends": {color: '#68D1C5', fillColor: '#68D1C522'} // green
}

function drawAttributesOnCanvas(canvas, attributeMap, attributeName){
    if(!attributeMap.hasOwnProperty(attributeName)){
        return;
    }

    for(let l=0; l < attributeMap[attributeName].loc.length; l++){
        const box = attributeMap[attributeName].loc[l].box;
        selfie.drawRectangleOnCanvas(canvas, [
            {_x: box[0][0],_y: box[0][1]},
            {_x: box[1][0], _y: box[1][1]}
        ], attributeStyle[attributeName]);
    }
}

function drawAttributesUsingHtml(attributeMap, attributeName){
    if(!attributeMap.hasOwnProperty(attributeName)){
        return;
    }
 
    var containerDiv = document.getElementById("attributes-overlay-container");
    for(let l=0; l < attributeMap[attributeName].loc.length; l++){
        const box = attributeMap[attributeName].loc[l].box;
        selfie.drawRectangleUsingHtml(containerDiv, attributeName, box, handleHairAttributeClick)
    }
}

function translateShineToDullnessScore(shineScore){
    let dullnessScore = 0;
    if(shineScore == 0){
        dullnessScore = 3;
    } else{
        dullnessScore = 0.5*(4 - shineScore);
    }
    return dullnessScore;
}

function handleTangentModalClose(){
    let tooltip = document.querySelector(".tangent-attribute-tooltip-container");
    tooltip.setAttribute("style", "display: none;")
}

function handleHairAttributeClick(event, attribute) {
  const div = event.currentTarget; 
  if (div) {
    const rect = div.getBoundingClientRect();
    const tooltip = document.querySelector(".tangent-attribute-tooltip-container");
    const pointerElement = document.querySelector(".tangent-tooltip-pointer");
    const attributeElement = document.querySelector(".tangent-attribute");

    // Set attribute text
    attributeElement.innerHTML = getAttributeText(attribute);
    // attributeElement.innerHTML = `Spotted ${attribute.toLowerCase()}? <a href='/products/hg-shampoo?variant=45217315160202' target='_blank' class='tooltip-product-link'>Anti-thinning shampoo</a> to the rescue!`;

    const tooltipWidth = 300; // fixed width from CSS
    const arrowDiagonalHalf = 8.5;
    const tooltipHeight = 50; // fixed height from CSS
    const arrowOffsetY = tooltipHeight + arrowDiagonalHalf;

    // Calculate initial position
    let leftPosition = rect.left;
    const topPosition = rect.top - arrowOffsetY;

    // Check if tooltip overflows to the right
    if (leftPosition + tooltipWidth > window.innerWidth) {
      leftPosition = window.innerWidth - tooltipWidth - 20; // 20px padding from edge
    }

    // Check if tooltip overflows to the left
    if (leftPosition < 0) {
      leftPosition = 10;
    }

    tooltip.setAttribute(
      "style",
      `display: block; top: ${topPosition}px; left: ${leftPosition}px;`
    );

    // Arrow position (center of origin box, adjusted if tooltip shifted)
    let pointerPosition = rect.left + rect.width / 2 - leftPosition - 10;
    pointerElement.setAttribute("style", `left: ${pointerPosition}px;`);
  }
}

const getAttributeText = (attributeName) => {
  return heroProductText[attributeName];
}

function drawChart(params) {
    var attr = params.attributes;
    var attr_list = [];

    selfie.init().then(() => {
        showLoader(false);
        if(selfie.imageWidth<300){
            setCanvasSize(selfie.imageHeight+"px",selfie.imageWidth+"px");
        }
        else{
            setCanvasSize(selfie.imageHeight+"px","100%");
        }
        const attributeNames = ["Dryness", "Frizz", "Flyaways", "Shine", "Split Ends"]
        for (const attributeName of attributeNames){
            if(attributeName == "Shine"){
                attr_list.push({
                    "x": "Dullness",
                    "value": translateShineToDullnessScore(getAttributeScore(attr, attributeName))
                });
            } else if(attributeName == "Flyaways"){
                attr_list.push({
                    "x": "Frizz",
                    "value": getAttributeScore(attr, attributeName)
                });
            }else {
                attr_list.push({
                    "x": attributeName,
                    "value": getAttributeScore(attr, attributeName)
                });
            }
            let updatedAttributeName = attributeName == "Flyaways" ? "Frizz" : attributeName;
            let updatedAttributes = moveFlyawaysToFrizz(attr);
            // drawAttributesOnCanvas(canvas, attr, attributeName)
            drawAttributesUsingHtml(updatedAttributes, updatedAttributeName, handleHairAttributeClick)
        }

        attr_list.push({
            "x": "Damage",
            "value": getAttributeScore(params, "damage")
        });
        setElementDisplay("#chart-loader","none");
        // create a chart and keep max value for frizz
        let withMaxFrizzValue = processHairData(attr_list)
        drawRadarChart(withMaxFrizzValue)

        
        // const recommendation = getRecommendedConcern(params);

    }).catch((error) => {
        console.log("Error in loading model "+error);
        showLoader(false);
        console.log(error.stack);
    });

}

function moveFlyawaysToFrizz(data) {
  if (!data.Flyaways) return data; // nothing to do

  if (data.Frizz) {
    // If Frizz exists, append Flyaways loc
    data.Frizz.loc = [...data.Frizz.loc, ...data.Flyaways.loc];
    // Optionally, you can decide which score to keep. Here I keep max.
    data.Frizz.score = Math.max(data.Frizz.score, data.Flyaways.score);
  } else {
    // If Frizz doesn't exist, create it
    data.Frizz = {
      loc: [...data.Flyaways.loc],
      score: data.Flyaways.score
    };
  }

  // Remove Flyaways
  delete data.Flyaways;

  return data;
}



function processHairData(data) {
  const hairThinningHeader = document.querySelector(".hair-thinning-info");
  let maxFrizz = null;
  let damage = 0, splitEnds = 0, dryness = 0;

  // Process items
  data.forEach(item => {
    if (item.x === "Frizz") {
      if (!maxFrizz || item.value > maxFrizz.value) {
        maxFrizz = item;
      }
    }
    if (item.x === "Damage") damage = item.value;
    if (item.x === "Split Ends") splitEnds = item.value;
    if (item.x === "Dryness") dryness = item.value;
  });

  // Calculate Thinning score
  const thinningScore = Math.round(0.5 * damage + 0.3 * splitEnds + 0.2 * dryness);

  // Build new array
  const result = [
    ...data.filter(item => item.x !== "Frizz"),
    ...(maxFrizz ? [maxFrizz] : []),
    { x: "Thinning", value: thinningScore }
  ];

  hairThinningHeader.innerHTML = hairThinningInfo[thinningScore];
  return result;
}


// Show / Hide loader
function showLoader(show) {
  const $loader = $('#tangent-selfie-loader');
  if (show) {
    $loader
      .addClass('show-loader')
      .css('display', 'flex');
  } else {
    $loader
      .removeClass('show-loader')
      .css('display', 'none');
  }
}

function setCanvasSize(height, width) {
  const sizeStyle = `height: ${height}px; width: ${width}px;`;
  canvas.setAttribute("style", sizeStyle);
  overlays_container_div.setAttribute("style", sizeStyle);
}

function setRecommendationText(text){
    document.getElementById("recommendation_text").innerHTML = text;
}

function setHairDamageImage(damage_score){        
    document.getElementById("hair_damage_img").setAttribute("src",condition_img_map[damage_score]);    
}

function setSelfieImage(url){
    document.getElementById("selfie_img").setAttribute("src",url);
}

function drawRadarChart(list){
    var chart = anychart.radar();

    var interactivity = chart.interactivity();
    interactivity.hoverMode("bySpot");
    interactivity.spotRadius(0);

    chart.tooltip(false);
    chart.area(list);
    chart.yScale().ticks().interval(1);
    chart.yScale().minimum(0);
    chart.yScale().maximum(4);

    var labels = chart.yAxis().labels();
    labels.enabled(false);

    chart.container("graph_container");
    chart.draw();
}

function getHairType(hairTypesProbabilityDistribution){
    const hairType = Object.keys(hairTypesProbabilityDistribution).reduce(
        (a, b) => hairTypesProbabilityDistribution[a] > hairTypesProbabilityDistribution[b] ? a : b);
    return hairType.toLowerCase()
}

function getHairColor(hairColorProbabilityDistribution){
    const hairColor = Object.keys(hairColorProbabilityDistribution).reduce(
        (a, b) => hairColorProbabilityDistribution[a] > hairColorProbabilityDistribution[b] ? a : b);
    return hairColor.toLowerCase()
}

function getRecommendedConcern(params){    
    return "damage";
  
    let recommendation = undefined;
    
    var attr = params.attributes;
    
    const hairType = getHairType(params.hairstyle);
    const hairColor = getHairType(params.haircolor);
    
    const concern_keys = ["Dryness", "Frizz", "Split Ends", "damage"];
    var biggestConcern = getMaxNonZeroHairCondition(params, concern_keys);

    if(hairType == "curly" || hairType == "kinky"){
        recommendation = "curly";
    }
    else if(hairColor == "blond"){
        recommendation = "blond";
    }
    else if(biggestConcern != undefined){
        recommendation = biggestConcern;
    }
    else if(getAttributeScore(attr, "Shine", 0)<1){
        recommendation = "Shine";
    }
    else{
        recommendation = "Default";
    }
    return recommendation;
}

function getMaxNonZeroHairCondition(params, keys){
    var maxValue = 0;
    var maxKey;
    var attributes = params.attributes;
    for (var i = 0; i < keys.length; i++) {
        if(keys[i]=="damage"){
            if(getAttributeScore(params,keys[i],0)>maxValue){
                maxValue = getAttributeScore(params,keys[i],0);
                maxKey = keys[i];
            }
        }
        else{
            if(getAttributeScore(attributes,keys[i],0)>maxValue){
                maxValue = getAttributeScore(attributes,keys[i],0);
                maxKey = keys[i];
            }
        }
    }
    return maxKey;
}
  
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function showProductsRecommendation(response){
    const tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    setTabOpen(response.tags);
  
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData(); 

    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};

  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          const variant = getSelectedVariant(product, selected_variants[product.id]);
            
          // Track selected product variant
          tangent_selected_product_map[product.id] = extractVariantId(variant.id);
          
          // Generate product HTML and append it to the fragment
          const product_html = getProductHTML(product, p, variant, section, sections);
          if(product_html){
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = product_html;

            // Append the created product HTML to the fragment
            while (tempDiv.firstChild) {
              fragment.appendChild(tempDiv.firstChild);
            }
          }
        }
      }
    }

    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}

function extractVariantId(variantId) {
  return variantId.replace("gid://shopify/ProductVariant/", "");
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractVariantId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function getProductHTML(product, index, variant, section, sections) {
  const variantId = extractVariantId(variant.id);
  // Setting default / first variant data
  const variant_image_url = getVariantImage(variant, product);
  const variant_product_url = `${product.onlineStoreUrl}?variant=${variantId}`;
  let variantTitle = "("+variant.title+")";
  if(variant.title=="Default Title"){
    variantTitle="";
  }
  let buttonClass="";
  let buttonText = default_addToCartText;

  const productMiniDescription = getProductMiniDescription(product);
  const available = isProductAvailable(product, variant);
  
  if(available){
    updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
     
    // Product View HTML using template literals
    const product_html = `
      <div class="product-card">
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
          <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
          <p class="tangent-product-title tangent_product_title_text">${product.title} <br>${variantTitle}</p>
          ${productMiniDescription}
          <p id="price_tangent_product_${index}" class="tangent_product_price_text">${tangent_client_domain_currency}${variant.price}</p>
        </a>
        <button class="tangent-product-add-btn-wrapper tangent_add_to_cart_button ${buttonClass}" id="${variantId}" data-section="${section}"><span>${buttonText}</span></button>
        
        ${getSellingPlanButton(product, variantId, buttonClass)}
      </div>
    `;
    return product_html;
  }
  return null;
}

function getProductMiniDescription(product) {
  const desc = product?.product_mini_description?.value;
  return desc ? `<p class="tangent-product-mini-description body--xsmall">${desc}</p>` : '';
}

function extractSellingId(id){
  return id.replace("gid://shopify/SellingPlan/", "");
}

function getSellingPlanButton(product, variantId, buttonClass) {
  if (product?.sellingPlanGroups?.edges?.length > 0) {
    const groupNode = product.sellingPlanGroups.edges[0].node;

    if (groupNode?.sellingPlans?.edges?.length > 0) {
      const planNode = groupNode.sellingPlans.edges[0].node;
      const planId = extractSellingId(planNode.id);
      return `<button class="tangent-product-add-btn-wrapper-subscribe tangent_add_to_cart_button ${buttonClass}" id="${variantId}" data-planid="${planId}"><span>Subscribe</span></button>`;
    }
  }
  return ``;
}


function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

function setTabOpen(tags){
    // Setting 1st tab active by default
    document.querySelector("#tab-wrapper").style.display="block";
    // By Default first tab is selected and opened
    document.querySelectorAll(".tabcontent")[1].style.display="flex";
    document.querySelectorAll(".tablinks")[1].classList.add("active");
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;

    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "block" : "none";
                }
            }
        }
    }
}

const getVariantImage = (variant, product) => {
  if(variant.image?.url){
    return variant.image.url; 
  }
  else{
    return product.images.nodes[0].url
  }
  return 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
}

function createFormDataFromIds(idArray, element) {
  const section = element.getAttribute('data-section');
  if (element.getAttribute('data-planid')) {
    return {
      items: idArray.map(id => ({
        id: id,
        quantity: 1,
        selling_plan: element.getAttribute('data-planid')
      }))
    };
  }

  const items = idArray.map(id => {
    const baseItem = { id, quantity: 1 };

    const sectionTypeMap = {
      section_advanced: "tangent-advanced-product",
      section_essentials: "tangent-essentials-product"
    };

    if (sectionTypeMap[section]) {
      baseItem.properties = {
        _type: sectionTypeMap[section],
        _variantIds: idArray
      };
    }

    return baseItem;
  });
  
  return { items };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([extractVariantId(element.id)],element);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list, element);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  let resultText = default_addedToCartText;
  if(element.getAttribute('data-planid')){
    resultText ="subscription added!";
  }

  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = resultText;
    element.classList.add("added-to-cart-style"); 
    var drawer = document.querySelector("cart-drawer"); 
    drawer.fullUpdate().then(() => { 
    drawer.open(); }); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}


// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    if(section_name!="section_selfie" && section_name!="section_upsell" && section_name != "section_haircare_routine"){
      section_container.classList.add("tabcontent");
    }
    return section_container;
}

function createSectionAddAllToCart(section_name) {
    const add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add("section_add_all_to_cart", section_name+"_add_all_to_cart", "btn");

    const discountSections = ["section_advanced", "section_essentials"];

    add_all_to_cart_button.innerHTML = discountSections.includes(section_name)
      ? "add all, get 30% off!"
      : default_add_all_to_cart_text;


    add_all_to_cart_button.setAttribute("data-section", section_name);
    // Enabling listener
    add_all_to_cart_button.addEventListener(
        'click',
        function () { addAllTocartFunction(add_all_to_cart_button); },
        false
    );
    return add_all_to_cart_button;
}

function createRetryQuizButton({
    quizUrl,
    buttonText = "Retry Quiz"
} = {}) {

    const button = document.createElement("a");

    button.href = quizUrl;
    button.className = "tangent-retry-quiz-btn";
    button.innerText = buttonText;

    return button;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tab_button.addEventListener(
        'click',
        function () { switchTab(this); },
        false
    );
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      if(section_name!=="section_upsell"){
        section_container.appendChild(createRetryQuizButton({
            quizUrl: "https://bondiboost.com/pages/ai-hair-quiz"
        }))
      }
      
      if(section_name!="section_upsell"){
        createTabButton(section_name);
      }
      // Add to main container wrapper
      tangent_sections_wrapper_element.appendChild(section_container);
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}


// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "flex";
  document.getElementById(element.name+"_tab_button").classList.add("active");
}


// Enabling button listeners
function enableButtonListener() {

    // Regular add to cart buttons
    const all_btns = document.querySelectorAll(
        ".tangent-product-add-btn-wrapper"
    );

    for (let b = 0; b < all_btns.length; b++) {

        // Prevent duplicate listeners
        all_btns[b].removeEventListener(
            "click",
            handleAddToCartClick
        );

        all_btns[b].addEventListener(
            "click",
            handleAddToCartClick,
            false
        );
    }

    // Subscribe buttons
    const all_subscribe_btns = document.querySelectorAll(
        ".tangent-product-add-btn-wrapper-subscribe"
    );

    for (let s = 0; s < all_subscribe_btns.length; s++) {

        // Prevent duplicate listeners
        all_subscribe_btns[s].removeEventListener(
            "click",
            handleAddToCartClick
        );

        all_subscribe_btns[s].addEventListener(
            "click",
            handleAddToCartClick,
            false
        );
    }
}

// Shared handler
function handleAddToCartClick() {
    addToCart(this);
}

function loadElementsOnResponseData() {

    // Show all hidden elements
    const all_elements = document.querySelectorAll(".load-on-data");

    for (let ae = 0; ae < all_elements.length; ae++) {
        all_elements[ae].style.display = "block";
    }

    // Hide upsell container if no product cards exist
    const upsellGrid = document.getElementById(
        "section_upsell_product_grid"
    );

    if (upsellGrid) {

        const productCards = upsellGrid.querySelectorAll(".product-card");

        if (productCards.length === 0) {

            const upsellContainer = document.getElementById(
                "section_upsell_container"
            );

            if (upsellContainer) {
                upsellContainer.style.display = "none";
            }
        }
    }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}


class TangentSelfie {
    canvas;
	constructor(imgId){
		this.img = document.getElementById(imgId);
	}

	async init() {
      try{
        // Handle the case if the image is not loaded yet
        const result = await this.imageLoad(this.img);
        await this.sleep(2000); 
        this.imageWidth = this.img.clientWidth;
        this.imageHeight = this.img.clientHeight;
      } catch(e){
        console.log(e);
      }
	}

	async imageLoad(imgElem) {
	    return new Promise(res => {
	        if (imgElem.complete) {
	            return res();
	        }
	        imgElem.onload = () => res();
	        imgElem.onerror = () => res();
	    });
	}

	async sleep(ms) {
	    return new Promise(resolve => setTimeout(resolve, ms));
	}

	get imgWidth(){
		return this.imageWidth
	}

	get imgHeight(){
		return this.imageHeight
	}

    scaleCanvas(canvas){
		var ctx = canvas.getContext("2d");
		ctx.resetTransform();
		ctx.scale(canvas.width/this.img.naturalWidth, canvas.height/this.img.naturalHeight);
        ctx.translate(0.5, 0.5);
    }

	drawRectangleOnCanvas(canvas, rectanglePoints, style){
		this.scaleCanvas(canvas)
		var ctx = canvas.getContext("2d");
        
        ctx.lineWidth = 10;
        ctx.strokeStyle = style['color'];
		
        ctx.beginPath();
		ctx.rect(rectanglePoints[0]._x, rectanglePoints[0]._y, rectanglePoints[1]._x - rectanglePoints[0]._x, rectanglePoints[1]._y - rectanglePoints[0]._y);

        ctx.fillStyle = style['fillColor'];
		ctx.fill();
		ctx.stroke();
	}

    getScaledBox(containerDiv, box){
        const [[left_x, top_y], [right_x, bottom_y]] = box
        const viewWidth = containerDiv.getBoundingClientRect().width
        const viewHeight = containerDiv.getBoundingClientRect().height
        
        return [
            [(left_x*viewWidth)/this.img.naturalWidth, (top_y*viewHeight)/this.img.naturalHeight], 
            [(right_x*viewWidth)/this.img.naturalWidth, (bottom_y*viewHeight)/this.img.naturalHeight]
        ]
    }

    drawRectangleUsingHtml(containerDiv, attributeName, box, handleHairAttributeClick = null){
        let div = this.getAttributeBoxDiv(containerDiv, attributeName, box)
        // let span = this.getAttributeNameSpan(attributeName)
        // div.appendChild(span);
        containerDiv.appendChild(div);
        if(handleHairAttributeClick){
            div.addEventListener("click", (event) => handleHairAttributeClick(event, attributeName))
        }
    }
    
    getAttributeBoxDiv(containerDiv, attributeName, box){
        // if(attributeName == "Flyaways") attributeName = "Frizz";
        const [[left_x, top_y], [right_x, bottom_y]] = this.getScaledBox(containerDiv, box)
    
        var div = document.createElement('div');
        div.className = 'attributes-overlay';
        div.style.top = top_y + 'px';
        div.style.left = left_x + 'px';
        div.style.width = (right_x - left_x) + 'px';
        div.style.height = (bottom_y - top_y) + 'px';
        div.style.borderColor = attributeStyle[attributeName]['color'];
        div.style.backgroundColor = attributeStyle[attributeName]['fillColor'];
        div.innerHTML = `&nbsp;`;
        return div;
    }
    
    getAttributeNameSpan(attributeName){
        var span = document.createElement('span');
        span.className = 'attribute-text';
        span.style.backgroundColor = attributeStyle[attributeName]['color']
        span.innerHTML = attributeName;
    
        return span;
    }

}

const canvas = document.getElementById('selfie_canvas');
const overlays_container_div = document.getElementById('attributes-overlay-container');
let selfie = new TangentSelfie('selfie_img');
  